import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledWhoIsJadeSoft = styled(Box)(({ theme }) => ({
    minHeight: 'calc(130vh - 82px)',
    position: 'relative',
    overflow: 'visible',
    justifyContent: 'center',
    // backgroundColor: '#000000',
    width: '100%',
    '& .homeBg': {
        position: 'absolute',
        height: '100%',
        width: '100%',
        // background: 'red',

        '& .videoElement': {
            position: 'absolute',
            top: '-60px',
            left: 0,
            height: '130%',
            width: '100%',
            objectFit: 'cover',
            zIndex: -1,
        },
    },

    '& .homeContent': {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1 /* Ensures content is above the video */,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: theme.spacing(30),
        // paddingLeft: '20%',
        padding: '10% 17.7%',

        '& .bannerText': {
            background: theme.customGradients.primary,
            '-webkit-background-clip': 'text',
            '-webkit-text-fill-color': 'transparent',
            boxShadow: theme.palette.boxShadow.secondary,
            font: theme.typography.h3.font,
            fontWeight: 400,
            textAlign: 'center',
        },

        [theme.breakpoints.down('lg')]: {
            // paddingLeft: 1,
            '& .iconBrandLogo': {
                width: '300px',
                height: '100px',
            },
        },
    },

    [theme.breakpoints.down('lg')]: {
        // minHeight: '100vh',
        minHeight: 'unset',
        margin: theme.spacing(0),

        '& .homeContent': {
            position: 'static',
            marginTop: theme.spacing(0),
            marginBottom: theme.spacing(0),
            justifyContent: 'center',
            padding: '0 20px',

            '& .bannerText': {
                margin: theme.spacing(0, 1),
                font: theme.typography.h6.font,
                fontWeight: `${500} !important`,
            },

            '& .label2': {
                '@media (width: 320px)': {
                    fontSize: '15px !important',
                },
                '@media (width: 344px)': {
                    fontSize: '16px !important',
                },
                '@media (width: 360px)': {
                    fontSize: '16px !important',
                },
                '@media (width: 375px)': {
                    fontSize: '17px !important',
                },
            },
        },
        '& .homeBg': {
            '& .videoElement': {
                position: 'absolute',
                // top: 0,
                left: 0,
                // height: '100%',
                width: '100%',
                objectFit: 'cover',
                zIndex: -1,
            },
        }
    },
}));

export default StyledWhoIsJadeSoft;
